import React, { Component } from 'react';
import styles from './consequences-heading.scss';
import { ConsequencesHeadingProps } from 'app/area/codetable/list/list-renderer/types';
import { SupportedListScreens } from 'app/area/codetable/list/list-renderer/supported-screens';

export class ConsequencesHeading extends Component<ConsequencesHeadingProps> {

  public render() {

    const { screenPayload: { screenProps }, translation, screenPayload, metadata } = this.props;

    return <div className={styles.headingContainer}>
      <div className={styles.defaultColumn}>{metadata?.codetableCategory?.label ??
        (!!screenProps?.listCategoryLabel ? screenProps.listCategoryLabel(translation) : translation?.consequence_type)}</div>
      {screenPayload.id === SupportedListScreens.ConsequencesSeverity ?
        <div className={styles.defaultColumn}>{translation.severity_description}</div> : null}
      {screenPayload.id === SupportedListScreens.ConsequencesRecurrence ?
        <div className={styles.defaultColumn}>{translation.recurrence_description}</div> : null}
      {screenPayload.id === SupportedListScreens.ConsequencesLikelihood ?
        <div className={styles.defaultColumn}>{translation.likelihood_description}</div> : null}
      {screenPayload.id === SupportedListScreens.InteractionOption ?
        <div className={styles.defaultColumn}>{translation.interaction_option}</div> : null}
      {screenPayload.id === SupportedListScreens.Reference ?
        <div className={styles.defaultColumn}>{translation.reference}</div> : null}
      {metadata?.features?.sequence ?
        <div className={styles.fixedColumn}>{translation.sequence}</div> : null}
      <div className={styles.fixedColumn} />
    </div>;
  }
}
